import { render, staticRenderFns } from "./SolarPanels.vue?vue&type=template&id=06ca553c&scoped=true"
import script from "./SolarPanels.vue?vue&type=script&lang=js"
export * from "./SolarPanels.vue?vue&type=script&lang=js"
import style0 from "./SolarPanels.vue?vue&type=style&index=0&id=06ca553c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca553c",
  null
  
)

export default component.exports